import type { AgentManifest } from '@indipia/shared';
import { routes, shareRoutes } from './src/routes';

export { SchedulerSiteEmbed, type SchedulerSiteEmbedProps } from './src/pages/SchedulerSiteEmbed';
export type { DirtyHandle } from './src/pages/SchedulerPage';
export { SchedulerHostProvider, type SchedulerHostContextValue } from './src/context/SchedulerHostContext';

export const manifest: AgentManifest = {
  agentId: 'scheduler',
  routes,
  shareRoutes,
  menuItems: [
    {
      id: 'scheduler',
      label: '인디플래너',
      icon: 'calendar',
      path: '/agents/scheduler',
      category: 'common',
      order: 60,
    },
  ],
  permissions: ['OWNER', 'STAFF'],
};
